import { render, staticRenderFns } from "./tablero.vue?vue&type=template&id=087924c8&"
import script from "./tablero.vue?vue&type=script&lang=js&"
export * from "./tablero.vue?vue&type=script&lang=js&"
import style0 from "./tablero.vue?vue&type=style&index=0&class=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports